export function formatPhoneInput(value: string): string {
    if (/[^\d\s()+.-]/.test(value)) {
        return value
    }

    const trimmed = value.trim()
    if (trimmed.startsWith('+') && !trimmed.startsWith('+1')) {
        return value
    }

    let digits = value.replace(/\D/g, '')
    if (digits.length === 11 && digits.startsWith('1')) {
        digits = digits.slice(1)
    }
    if (digits.length !== 10) {
        return value
    }

    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}
